import React, { useRef, useEffect, useState } from "react";
import { Card, Typography, Box, Grid, IconButton ,Button} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { useAuth } from "../../../AuthProvider";
import Avatar from "@mui/material/Avatar";


const baseUrl = process.env.REACT_APP_API_BASE_URL;
const StudentDetailView = () => {
  const navigate = useNavigate();
  const componentRef = useRef();
  const {oId,board}=useAuth();
  const { studentId } = useParams();
  const location = useLocation();
  
  const [studentDetails, setStudentDetails] = useState(null);
  const [studentPassphoto, setStudentPassphoto] = useState(null);
  // const studentId = student.studentId;
  console.log("student id :"+studentId);

  useEffect(() => {
    if (studentId) {
      console.log("student id "+ studentId);
      const fetchData = async () => {
        try {
          const response = await fetch(`${baseUrl}/api/admission/getAllStudentsDetailsStudentId/${studentId}/${oId}`);
          const data = await response.json();
          setStudentDetails(data);

          // Convert base64 response to data URL if it's present
        if (data.passPhoto && data.passPhoto.trim() !== "") {
          const base64Image = `data:image/jpeg;base64,${data.passPhoto}`;
          setStudentPassphoto(base64Image);
        } else {
          setStudentPassphoto("/assets/Avatar.jpg"); // Fallback to default avatar
        }

        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    } else {
      console.warn("studentId is null or undefined.");
    }
  }, [studentId]);
  

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "",
  });

  return (
    <Card
      style={{
        width: "96%",
        borderRadius: "16px",
        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
        backgroundColor: "#f4f6f9",
        margin: "6% 1% 2% 1%",
        padding: "31px 30px",
        minHeight: "240mm",
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">

        <Box display="flex" alignItems="center">
          <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
            <KeyboardBackspaceIcon fontSize="medium" />
          </IconButton>
          <Typography variant="h4" sx={{ fontWeight: "bold", marginLeft: 1 }}>
            Admission Details
          </Typography>
        </Box>


        <Box display="flex" alignItems="center">
        <Button
  variant="contained" // Filled button
  sx={{
    backgroundColor: "#3C3972",
    color: "white",
    fontSize: "0.75rem", // Adjusts text size
    fontWeight:'bold',
    padding: "4px 12px", // Proper padding
    minWidth: "80px", // Ensures button is wide enough
    height: "30px", // Adjusts height
    textTransform: "none", // Keeps text as normal (no uppercase)
    borderRadius: "4px", // Slightly rounded corners
    marginRight:'10px',
    "&:hover": {
      backgroundColor: "#3C3972",
    },
  }}
  // onClick={() => navigate("/StudentUpdateDetails", { state: { studentId: studentId } })}
  onClick={() => navigate(`/StudentUpdateDetails/${studentId}`)}

>
  Edit Details
</Button>
        <Button
  variant="contained" // Filled button
  sx={{
    backgroundColor: "#3C3972",
    color: "white",
    fontSize: "0.75rem", // Adjusts text size
    fontWeight:'bold',
    padding: "4px 12px", // Proper padding
    minWidth: "80px", // Ensures button is wide enough
    height: "30px", // Adjusts height
    textTransform: "none", // Keeps text as normal (no uppercase)
    borderRadius: "4px", // Slightly rounded corners
    "&:hover": {
      backgroundColor: "#3C3972",
    },
  }}
  onClick={handlePrint}
>
  PRINT
</Button>
</Box>
      </Box>

      {studentDetails ? (
            <>

      <div style={{ padding: "30px", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div
          ref={componentRef}
          
          style={{
            padding: "30px",
            boxShadow: "inset 0 0 0 2.5px black",
            width: "210mm",
            minHeight: "200mm",
            marginTop: "5px",
            boxSizing: "border-box"
        }}
        >
          <style>
  {`
    @media print {
     title {
    display: none;
  }
      body {
        -webkit-print-color-adjust: exact;

      }
        
      @page {
        size: A4;
        margin: 10mm; /* Adjust margin to avoid content cutoff */
      }
      #Admission-container {
        width: 190mm; /* Ensure it fits within print margins */
        margin: auto; /* Center the form */
        height: auto;
        page-break-inside: avoid;
        // border: 2.5px solid black; /* Ensure border remains */
      }
      .no-break {
        page-break-inside: avoid;
      }
    }
  `}
</style>

         
          {/* <style>
                {`
                    @media print {
                        body {
                            -webkit-print-color-adjust: exact;
                        }
                        #Admission-container {
                            width: 100%;
                            height: 297mm;
                            page-break-inside: avoid;
                            padding: 20px;
                            box-sizing: border-box;
                        }
                        .no-break {
                            page-break-inside: avoid;
                        }
                    }
                `}
          </style> */}
          

          <Box display="flex" flexDirection="column" alignItems="center" sx={{marginBottom:'20px'}}>
            <Typography variant="h5" fontWeight="bold">
              Student Admission Details
            </Typography>
          </Box>

        
             {/* Header */}
             <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
  {/* Left Section - Student Details */}
  <Box ml={3}>
  <Typography variant="h5" style={{ marginLeft: "30px"}}>
              {/* <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                <span style={{ fontWeight: "bold" ,paddingRight:'40px'}}>Admission No:</span>
                <span>{studentDetails.admissionNumber || ""}</span>
              </div> */}
              <div style={{ display: "flex", justifyContent: "space-between", width: "100%" ,paddingBottom:'10px'}}>
                <span style={{ fontWeight: "bold" ,paddingRight:'40px'}}>Admission Date:</span>
                <span>{studentDetails.admissionDate || ""}</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", width: "100%",paddingBottom:'10px' }}>
                <span style={{ fontWeight: "bold" ,paddingRight:'40px'}}>Joined Year:</span>
                <span>{studentDetails.studentJoinedYear || ""}</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", width: "100%" ,paddingBottom:'10px'}}>
                <span style={{ fontWeight: "bold",paddingRight:'40px' }}>Joined Class:</span>
                <span>{studentDetails.studentJoinedClass || ""}</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", width: "100%" ,paddingBottom:'10px'}}>
                <span style={{ fontWeight: "bold",paddingRight:'40px' }}>Roll No:</span>
                <span>{studentDetails.studentRollNumber || ""}</span>
              </div>
            </Typography>
  </Box>

  {/* Right Section - Student Image */}
  <Box mr={3}>
 
<img
  src={studentPassphoto}
  alt="Student Photo"
  style={{
    width: "105px",
    height: "120px",
    objectFit: "cover",
    border: "2px solid black",
    borderRadius: "2px",
  }}
/>


  </Box>
</Box>

          {/* Sections */}
          <Grid
            container
            spacing={2}
            className="no-break"
            style={{ marginTop: "20px" }}
          >
            <Grid item xs={6}>
              <Box
                sx={{
                  border: "1px solid",
                  padding: "10px",
                  borderRadius: "10px",
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  School Information
                </Typography>
                <hr />
                <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px' }}>
                    <span>Admission No:</span> <span style={{ fontWeight: "normal" }}>{studentDetails.customAdmissionNumber}</span>
                  </Typography>
                <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold",paddingBottom:'10px' }}>
                  <span>Admission Date:</span>
                  <span style={{ fontWeight: "normal" }}>{studentDetails.admissionDate}</span>
                </Typography>
                <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
                  <span>Joined Year:</span>
                  <span style={{ fontWeight: "normal" }}>{studentDetails.studentJoinedYear}</span>
                </Typography>
                  
                  <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px' }}>
                    <span>Current Year:</span> <span style={{ fontWeight: "normal" }}>{studentDetails.academicYear}</span>
                  </Typography>
                  <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px' }}>
                    <span>Student Id:</span> <span style={{ fontWeight: "normal" }}>{studentDetails.studentId}</span>
                  </Typography>
                  {/* <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px' }}>
                    <span>Status:</span> <span style={{ fontWeight: "normal" }}>{studentDetails.status}</span>
                  </Typography> */}
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box
                sx={{
                  border: "1px solid",
                  padding: "10px",
                  borderRadius: "10px",
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  Student Information
                </Typography>
                <hr />
              
                <Box>
                <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px' }}>
                    <span>Full Name:</span> <span style={{ fontWeight: "normal" }}>{studentDetails.surName} {studentDetails.firstName} {studentDetails.lastName}</span>
                  </Typography>
                  {(board === "INTERMEDIATE" ) && (
                  <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold",paddingBottom:'10px' }}>
                  <span>Course:</span>
                  <span style={{ fontWeight: "normal" }}>{studentDetails.course}</span>
                </Typography>
              )}

                <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold",paddingBottom:'10px' }}>
                  <span>Class:</span>
                  <span style={{ fontWeight: "normal" }}>{studentDetails.romanNumberClass}</span>
                </Typography>
                <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
                  <span>Section:</span>
                  <span style={{ fontWeight: "normal" }}>{studentDetails.sections}</span>
                </Typography>
                  
                  <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px' }}>
                    <span>Gender:</span> <span style={{ fontWeight: "normal" }}>{studentDetails.gender}</span>
                  </Typography>
                  <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold",paddingBottom:'10px'  }}>
                    <span>Date of Birth:</span> <span style={{ fontWeight: "normal" }}>{studentDetails.dob}</span>
                  </Typography>
                 
                </Box>

              </Box>
            </Grid>
          </Grid>

          {/* Parent Information */}
          <Box
            className="no-break"
            sx={{
              margin: "20px 0",
              padding: "10px",
              border: "1px solid",
              borderRadius: "10px",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Parent Information
            </Typography>
            <hr />
            <Grid container spacing={2}>
              <Grid item xs={6}  >
                <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
                  <span>Father's Name:</span> 
                  <span style={{ fontWeight: "normal" }}>{studentDetails.fathersFirstName} {studentDetails.fathersLastName}</span>
                </Typography>
                <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold",paddingBottom:'10px' }}>
                  <span>Father's Qualification:</span> 
                  <span style={{ fontWeight: "normal" }}>{studentDetails.fathersQualification || "N/A"}</span>
                </Typography>
                <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
                  <span>Father's Email:</span> 
                  <span style={{ fontWeight: "normal" }}>{studentDetails.fathersMailId || "N/A"}</span>
                </Typography>
                <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
                  <span>Father's Occupation:</span> 
                  <span style={{ fontWeight: "normal" }}>{studentDetails.fathersOccupation || "N/A"}</span>
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
                  <span>Mother's Name:</span> 
                  <span style={{ fontWeight: "normal" }}>{studentDetails.mothersFirstName} {studentDetails.mothersLastName}</span>
                </Typography>
                <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
                  <span>Mother's Qualification:</span> 
                  <span style={{ fontWeight: "normal" }}>{studentDetails.mothersQualification || "N/A"}</span>
                </Typography>
                <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
                  <span>Mother's Email:</span> 
                  <span style={{ fontWeight: "normal" }}>{studentDetails.mothersMailId || "N/A"}</span>
                </Typography>
                <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
                  <span>Mother's Occupation:</span> 
                  <span style={{ fontWeight: "normal" }}>{studentDetails.mothersOccupation || "N/A"}</span>
                </Typography>
              </Grid>
            </Grid>

          </Box>

          {/* Academic Information */}
          <Box
            className="no-break"
            sx={{ padding: "10px", border: "1px solid", borderRadius: "10px" }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Academic Information
            </Typography>
            <hr />
            <Grid container spacing={2}>
  <Grid item xs={6}>

  <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
      <span>Primary Contact:</span>
      <span style={{ fontWeight: "normal" }}>{studentDetails.primaryContact}</span>
    </Typography>
    <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
      <span>Alternate Contact:</span>
      <span style={{ fontWeight: "normal" }}>{studentDetails.alternateContact || "N/A"}</span>
    </Typography>
    <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
      <span>Aadhaar No:</span>
      <span style={{ fontWeight: "normal" }}>{studentDetails.aadharNumber}</span>
    </Typography>
  <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
                    <span>Religion:</span> <span style={{ fontWeight: "normal" }}>{studentDetails.religion || "N/A"}</span>
                  </Typography>
                  <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
                    <span>Caste:</span> <span style={{ fontWeight: "normal" }}>{studentDetails.caste || "N/A"}</span>
                  </Typography>
                  <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
                    <span>Nationality:</span> <span style={{ fontWeight: "normal" }}>{studentDetails.nationality || "N/A"}</span>
                  </Typography>
                 
    {/* <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold",paddingBottom:'10px' }}>
      <span>Grade:</span>
      <span style={{ fontWeight: "normal" }}>10</span>
    </Typography>
    <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
      <span>Subjects:</span>
      <span style={{ fontWeight: "normal" }}>Math, Science, English</span>
    </Typography>
    <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
      <span>Blood Group:</span>
      <span style={{ fontWeight: "normal" }}>A+</span>
    </Typography>
    <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
      <span>Attendance:</span>
      <span style={{ fontWeight: "normal" }}>95%</span>
    </Typography>
    <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold",paddingBottom:'10px' }}>
      <span>Father's Email:</span>
      <span style={{ fontWeight: "normal" }}>example@gmail.com</span>
    </Typography> */}
  </Grid>

  <Grid item xs={6}>

  <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold",paddingBottom:'10px' }}>
                    <span>Blood Group:</span> <span style={{ fontWeight: "normal" }}>{studentDetails.bloodGroup || "N/A"}</span>
                  </Typography>
                  <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
                    <span>Adress:</span> <span style={{ fontWeight: "normal" }}>{studentDetails.address || "N/A"}</span>
                  </Typography>
    <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold",paddingBottom:'10px' }}>
      <span>Performance:</span>
      <span style={{ fontWeight: "normal" }}>Excellent</span>
    </Typography>
   
    <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
      <span>Mole-1:</span>
      <span style={{ fontWeight: "normal" }}>{studentDetails.mole1}</span>
    </Typography>
    <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
      <span>Mole-2:</span>
      <span style={{ fontWeight: "normal" }}>{studentDetails.mole2}</span>
    </Typography>
    <Typography sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" ,paddingBottom:'10px'}}>
      <span>Hobbies:</span>
      <span style={{ fontWeight: "normal" }}>{"" || "N/A"}</span>
    </Typography>
  </Grid>
            </Grid>

          </Box>

          {/* School Comments & Stamp */}
          {/* <Grid
            container
            spacing={2}
            className="no-break"
            style={{ marginTop: "20px" }}
          >
            <Grid item xs={6}>
              <Box
                sx={{
                  border: "1px solid",
                  padding: "10px",
                  borderRadius: "10px",
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  Comments
                </Typography>
                <hr />
                <Typography>Excellent student with great potential.</Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box
                sx={{
                  border: "1px solid",
                  padding: "10px",
                  borderRadius: "10px",
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  School Stamp
                </Typography>
                <hr />
                <img
                  src="/assets/stamp.png"
                  alt="stamp"
                  style={{ width: "20px", height: "15px" }}
                />
              </Box>
            </Grid>
          </Grid> */}
            
        </div>
      </div>

      </>
          ) : (
            <Typography variant="h6" sx={{ textAlign: "center", marginTop: "20px" }}>
              Loading Student Admission Details...
            </Typography>
          )}
    </Card>
  );
};

export default StudentDetailView;
